<template>
	<v-select :items="languages" prepend-icon="map" v-model="selected"/>
</template>

<script>

	export default {
		name: "lang-select",
		props: {value: {}},
		components: {},
		data() {
			return {
				languages: [
					{text: "עברית", flag: "flag-icon-il", value: "he", url: "?lang=he"},
					{text: "English", flag: "flag-icon-us", value: "en", url: "?lang=en"},
					{text: "Portuguese", flag: "flag-icon-pt", value: "pt", url: "?lang=pt"}
				],

			};
		},
		computed: {
			selected: {
				get() {
					return this.value;
				},
				set(lang) {
					this.$emit("input", lang);
				}

			}
		},
		methods: {
			getUrlw(flag) {
				this.selected = flag;
				return "?lang=" + flag.value;
			}
		}
	};
</script>

<style scoped>

</style>
